var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: "实际进仓数据",
        "destroy-on-close": "",
        width: "1000px"
      },
      on: { close: _vm.onClose }
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            "label-width": "100px",
            "label-position": "left",
            "show-message": false,
            model: _vm.form
          }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 8 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "包装号",
                        required: "",
                        prop: "packageNo"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.form.packageNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "packageNo", $$v)
                          },
                          expression: "form.packageNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.getEstimatedData }
                    },
                    [_vm._v("填入预报数据")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "包装类型",
                        disabled: "",
                        prop: "packageType"
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled: "",
                          "select-type": _vm.selectTypeNames.basic_data_Packing,
                          filterable: "",
                          "default-value": _vm.form.packageType,
                          "tag-name": "englishName"
                        },
                        on: {
                          parentCallBack: function(p) {
                            return (_vm.form.packageType = p.value)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "实际进仓时间",
                        required: "",
                        prop: "incomeDate"
                      }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: { type: "date", clearable: "" },
                        model: {
                          value: _vm.form.incomeDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "incomeDate", $$v)
                          },
                          expression: "form.incomeDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { display: "flex" }, attrs: { gutter: 8 } },
            [
              _c(
                "el-col",
                { attrs: { span: 15 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "volume-col",
                      attrs: { required: "", label: "单箱实际体积" }
                    },
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { "margin-left": "-4px" },
                          attrs: { span: 4 }
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { required: "", prop: "length" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "长(CM)" },
                                model: {
                                  value: _vm.form.length,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "length", $$v)
                                  },
                                  expression: "form.length"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { span: 1 }
                        },
                        [_vm._v("x")]
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { required: "", prop: "width" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "宽(CM)" },
                                model: {
                                  value: _vm.form.width,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "width", $$v)
                                  },
                                  expression: "form.width"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { span: 1 }
                        },
                        [_vm._v("x")]
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { required: "", prop: "height" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "高(CM)" },
                                model: {
                                  value: _vm.form.height,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "height", $$v)
                                  },
                                  expression: "form.height"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { span: 1 }
                        },
                        [_vm._v("=")]
                      ),
                      _c("el-col", { attrs: { span: 4 } }, [
                        _vm._v(_vm._s(_vm.form.unitCubage))
                      ]),
                      _c("el-col", { attrs: { span: 4 } }, [_vm._v("CBM")])
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 8 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 20 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "单箱实际重量",
                                required: "",
                                prop: "unitGrossWeight"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.unitGrossWeight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "unitGrossWeight", $$v)
                                  },
                                  expression: "form.unitGrossWeight"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 4 } }, [_vm._v("KGS")])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                {
                  staticStyle: {
                    "flex-grow": "1",
                    display: "flex",
                    "align-items": "center",
                    "margin-top": "0"
                  },
                  attrs: { span: 3 }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 8 } },
                    [
                      _c("el-col", { attrs: { span: 5 } }, [_vm._v("x")]),
                      _c(
                        "el-col",
                        { attrs: { span: 14 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                "label-width": "0",
                                required: "",
                                prop: "quantity"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "箱数" },
                                model: {
                                  value: _vm.form.quantity,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "quantity", $$v)
                                  },
                                  expression: "form.quantity"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 5 } }, [_vm._v("=")])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                {
                  staticStyle: {
                    "flex-grow": "1",
                    display: "flex",
                    "justify-content": "center",
                    "margin-top": "0",
                    "flex-direction": "column"
                  },
                  attrs: { span: 6 }
                },
                [
                  _c(
                    "el-row",
                    { staticStyle: { width: "100%" } },
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { "font-size": "12px" },
                          attrs: { span: 7 }
                        },
                        [_vm._v("实际总体积")]
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { span: 12 }
                        },
                        [_vm._v(_vm._s(_vm.form.cubage))]
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { span: 5 }
                        },
                        [_vm._v("CBM")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticStyle: { width: "100%" } },
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { "font-size": "12px" },
                          attrs: { span: 7 }
                        },
                        [_vm._v("实际总重量")]
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { span: 12 }
                        },
                        [_vm._v(_vm._s(_vm.form.grossWeight))]
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { span: 5 }
                        },
                        [_vm._v("KGS")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { display: "flex" } },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", "min-height": "300px" },
            attrs: {
              "show-side-bar": false,
              "grid-options": _vm.gridOptions,
              "row-data": _vm.rowData,
              "column-defs": _vm.columnDefs
            }
          })
        ],
        1
      ),
      _c(
        "el-row",
        {
          staticStyle: { "margin-top": "15px" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-col",
            { attrs: { span: 18, offset: 6 } },
            [
              _c("el-form", [
                _c(
                  "span",
                  [
                    _c("el-button", { on: { click: _vm.onClose } }, [
                      _vm._v("取 消")
                    ]),
                    _c(
                      "el-button",
                      { attrs: { type: "primary" }, on: { click: _vm.onSave } },
                      [_vm._v("确定")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }